import { defineMessages } from 'react-intl';
var msg = defineMessages({
    headline: {
        defaultMessage: "Filiale w\u00E4hlen",
        id: 'checkoutStoreSelect.menu.headline',
    },
});
export default msg;
